import { useState, useCallback } from 'react';

export const useContentSelection = () => {
  const [selectedItems, setSelectedItems] = useState<Set<string>>(new Set());

  // Toggle individual item selection
  const toggleItemSelection = useCallback((itemId: string) => {
    setSelectedItems(prev => {
      const newSelection = new Set(prev);
      if (newSelection.has(itemId)) {
        newSelection.delete(itemId);
      } else {
        newSelection.add(itemId);
      }
      return newSelection;
    });
  }, []);

  // Clear all selections
  const clearSelection = useCallback(() => {
    setSelectedItems(new Set());
  }, []);

  // Select all items
  const selectAll = useCallback((itemIds: string[]) => {
    setSelectedItems(new Set(itemIds));
  }, []);

  // Check if item is selected
  const isSelected = useCallback((itemId: string) => {
    return selectedItems.has(itemId);
  }, [selectedItems]);

  return {
    selectedItems,
    toggleItemSelection,
    clearSelection,
    selectAll,
    isSelected,
    selectedCount: selectedItems.size
  };
}; 